import useIsMobile from '@/hooks/useIsMobile';
import ProductPickerPanelDesktop from './desktop';
import ProductPickerPanelMobile from './mobile';
import useProductPickerPanel from './useProductPickerPanel';

const ProductPickerPanel = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useProductPickerPanel();

  if (isMobile) {
    return <ProductPickerPanelMobile viewModel={viewModel} />;
  }

  return <ProductPickerPanelDesktop viewModel={viewModel} />;
};

export default ProductPickerPanel;